export default {
    STATUS: {
        PLAY: 'PLAY',
        PAUSE: 'PAUSE',
        STOP: 'STOP',
    },
    VOLUME: {
        STATUS: {
            MUTE: 'MUTE',
            UNMUTE: 'UNMUTE',
        },
        DEFAULT_VALUE: 100,
    },
};
